'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Base64String$$anon$37(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Base64String$$anon$37 as $c_Lpresto_types$Base64String$$anon$37 };
$p = $c_Lpresto_types$Base64String$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Base64String$$anon$37;
/** @constructor */
function $h_Lpresto_types$Base64String$$anon$37() {
}
export { $h_Lpresto_types$Base64String$$anon$37 as $h_Lpresto_types$Base64String$$anon$37 };
$h_Lpresto_types$Base64String$$anon$37.prototype = $p;
$p.bN = (function(str) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(str);
});
$p.bn = (function(t) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(t);
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Base64String$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Base64String$$anon$37, "presto.types$Base64String$$anon$37", ({
  YS: 1,
  K: 1
}));
export { $d_Lpresto_types$Base64String$$anon$37 as $d_Lpresto_types$Base64String$$anon$37 };
//# sourceMappingURL=presto.types$-Base64-String$$anon$37.js.map
